<script setup lang="ts">
import { MetricsDataTableRow } from "@/modules/explorer/components/Metrics/MetricResponseProcessor";
import MetricCell from "@/modules/explorer/components/Metrics/Table/MetricCell.vue";
import { computed } from "vue";
import DataTableResponseDTO = App.Data.Explorer.DataTable.DataTableResponseDTO;

const { dataTable, item, collapseHorizontal } = defineProps<{
	dataTable: DataTableResponseDTO;
	item: MetricsDataTableRow;
	collapseHorizontal: boolean;
}>();

const hasOffset = computed(() => !!dataTable.dataTableDO.offset_dimension);

const depthClass = computed(
	() => `metrics-data-table__row--depth-${item.row.depth}`
);

const isFirstOfGroup = computed(
	() => !collapseHorizontal || item.subRowIdx === 0
);
</script>

<template>
	<tr
		class="metrics-data-table__row"
		:class="[
			{
				'metrics-data-table__row--is-first':
					isFirstOfGroup && collapseHorizontal,
				'metrics-data-table__row--collapse-horizontal': collapseHorizontal,
			},
			depthClass,
		]"
	>
		<td
			v-if="isFirstOfGroup"
			:rowspan="collapseHorizontal ? item.row.subRows.length : undefined"
			class="metric-horizontal"
		>
			{{ item.row.horizontal }}
		</td>
		<td v-if="hasOffset">{{ item.subRow.offset }}</td>
		<metric-cell
			v-for="(metric, metricIdx) in item.subRow.metrics"
			:key="metricIdx"
			:data-table="dataTable"
			:metric="metric"
		/>
	</tr>
</template>
